import NM from './nm';

require('bootstrap-sass/assets/javascripts/bootstrap');
require('expose-loader?jQuery|expose-loader?$!jquery');
require('jquery-ui/ui/widget');
const Rails = require('rails-ujs');
require('./vendor/cocoon');

NM.on('ready', () => {
  if (!window._rails_loaded) Rails.start();
  require('./initializers//credit_card_form.initializer');
  require('./initializers/payment_method_selector.initializer');
  require('./initializers/timeago.initializer');
  require('./initializers/notification_preferences_form');

  require('./initializers/address.initializer');
  require('./initializers/attachment_input.initializer');
  require('./initializers/availability_rules.initializer');
  require('./initializers/category_autocomplete_input.initializer');
  require('./initializers/click_to_call.initializer');
  require('./initializers/collaborators.initializer');
  require('./initializers/complete_reservation.initializer');
  require('./initializers/condition_field.initializer');
  require('./initializers/datepickers.initializer');
  require('./initializers/dialog.initializer');
  require('./initializers/document_requirements.initializer');
  require('./initializers/draft_validation.initializer');
  require('./initializers/edit_user.initializer');
  require('./initializers/edit_user_form.initializer');
  require('./initializers/external_links.initializer');
  require('./initializers/flash_message.initializer');
  require('./initializers/forms.initializer');
  require('./initializers/hints.initializer');
  require('./initializers/image_input.initializer');
  require('./initializers/limiter.initializer');
  require('./initializers/linechart.initializer');
  require('./initializers/location_fields.initializer');
  require('./initializers/messages.initializer');
  require('./initializers/navigation.initializer');
  require('./initializers/order_items.initializer');
  require('./initializers/orders.initializer');
  require('./initializers/panel_tabs.initializer');
  require('./initializers/payment_modal.initializer');
  require('./initializers/phone_numbers.initializer');
  require('./initializers/photo_manipulator.initializer');
  require('./initializers/popup.initializer');
  require('./initializers/price_fields.initializer');
  require('./initializers/reviews.initializer');
  require('./initializers/saved_searches.initializer');
  require('./initializers/schedule.initializer');
  require('./initializers/shipping_profiles.initializer');
  require('./initializers/stripe.initializer');
  require('./initializers/sync_enabled_fields.initializer');
  require('./initializers/tags.initializer');
  require('./initializers/ticket_message.initializer');
  require('./initializers/white_label.initializer');
  require('./initializers/wish_list_buttons.initializer');
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/dashboard.js